import React, { PropTypes } from 'react';
import style from './style';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';

class AddButton extends React.Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired
  };
  render() {
    return (
      <div className={style.addButton}>
      <FloatingActionButton onClick={this.props.onClick}>
        <ContentAdd />
      </FloatingActionButton>
      </div>
    );
  }
}

export default AddButton;





// WEBPACK FOOTER //
// ./src/components/AddButton/index.jsx